module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAAkklEQVR4Ae3PgQaEQBSF4fM2iyAYCOzbZAEIi+iBIxIVUBfDoRAzcwXnuwTqP4KIiEiCwc5Rh8Ouc81zwiXvMsG83wTzOzZOeOS/djsnyuZXixt7rpwomW+AqCk1wfzCfJxYOJGfnxFwFW4TGfkaRAFzzkQfP52Yv6kxxbf+qf8wooJ5mPghUYsPnlRo8TYREZET0CZ2HrJ+WvUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/Search/baseline_expand_less_black_24dp.png
// module id = 115
// module chunks = 0